import React, { useEffect, useState } from "react";
import AccountName from "../account-name/account-name";
import { Skeleton } from "../skeleton/skeleton";
import { accountsStatusSelector } from "../../selectors/status";
import { useAppDispatch, useSelector } from "../../store/store";
import FilterInvestmentsModal from "./filter-investments-modal/filter-investments-modal";
import "./summary-filter.scss";
import {
  getDashFormattedDateStringFromISOString,
  isAfter,
} from "../../util/date-util";
import { useDates } from "../../selectors/dates";
import { setInvestmentSummaryDates, setDates } from "../../reducers/dates";
import { statementBalanceSelector } from "src/selectors/statement-balance";

export default function SummaryFilter() {
  const { available: accounts, selected: selectedAccounts } = useSelector(
    (state) => state.accounts
  );
  const {
    startDate,
    endDate,
    investmentSummaryStartDate,
    investmentSummaryEndDate,
    lastBusinessDate,
  } = useDates();
  const dispatch = useAppDispatch();
  const statementBalanceData = useSelector(statementBalanceSelector);

  useEffect(() => {
    let initialBalanceDate = "";

    if (
      statementBalanceData &&
      statementBalanceData.accountPrrs &&
      statementBalanceData.accountPrrs.length > 0
    ) {
      const oldestAccountStartDate = statementBalanceData.accountPrrs
        .map((account) => account.initialBalanceDate)
        .sort((a, b) => {
          if (isAfter(a, b)) {
            return 1;
          } else {
            return -1;
          }
        })[0];

      initialBalanceDate = new Date(oldestAccountStartDate).toISOString();
    }

    const realStartDate = isAfter(initialBalanceDate, startDate!)
      ? initialBalanceDate
      : startDate!;

    dispatch(
      setInvestmentSummaryDates({
        investmentSummaryStartDate: realStartDate,
        investmentSummaryEndDate: endDate!,
      })
    );
    dispatch(
      setDates({
        startDate: realStartDate,
        endDate: endDate!,
      })
    );
  }, [startDate, endDate, statementBalanceData]);

  return (
    <>
      <div className="summary-filter" data-testid="summary-filter">
        <h2 className="h5">Customize your view</h2>
        <div className="row">
          <div className="col-xs-4">
            <strong>Dates:</strong>
            <div data-testid="dates">
              <Skeleton selectors={[accountsStatusSelector]} height={24}>
                <>
                  {getDashFormattedDateStringFromISOString(
                    investmentSummaryStartDate!
                  )}{" "}
                  -{" "}
                  {getDashFormattedDateStringFromISOString(
                    investmentSummaryEndDate!
                  )}
                </>
              </Skeleton>
            </div>
          </div>
          <div className="col-xs-4">
            <strong>Accounts:</strong>
            <div data-testid="accounts">
              <Skeleton
                selectors={[accountsStatusSelector]}
                height={24}
                count={1}
              >
                {accounts.length === selectedAccounts.length
                  ? "Viewing all account(s)"
                  : renderAccounts(selectedAccounts)}
              </Skeleton>
            </div>
          </div>
          <div className="col-xs-4">
            <FilterInvestmentsModal />
          </div>
        </div>
      </div>
      <p data-testid="info-text">
        The following information is updated as of&nbsp;
        <Skeleton selectors={[accountsStatusSelector]} height={24} count={1}>
          {<>{getDashFormattedDateStringFromISOString(lastBusinessDate!)}</>}
        </Skeleton>
      </p>
    </>
  );
}

function renderAccounts(selectedAccounts: any) {
  return (
    <>
      <ul>
        {selectedAccounts.map((account: any, index: any) => {
          return (
            <li key={index} data-testid={`selectedAccount-${account.id}`}>
              <AccountName name={account.name} id={account.id} asLink={false} />
            </li>
          );
        })}
      </ul>
    </>
  );
}
